import Vue from 'vue'

// https://github.com/mengxiong10/vue2-datepicker
import DatePicker from 'vue2-datepicker'

import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/ko'

Vue.component('VDatePicker', DatePicker)
